import { MenuItem } from "@mui/material";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const MenuDesk = styled.nav`
  ul {
    display: flex;

    li {
      padding: 0 !important;
    }

    a {
      text-align: center;
    }
  }
`;

export const LogoWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    width: 24px;
  }

  @media (max-width: 480px) {
    font-size: 19px;
  }
`;

export const StyledLink = styled(NavLink)`
  color: #112758;
  text-decoration: none;
  text-decoration: none;
  width: 90%;
  height: 100%;
  padding: 8px 16px;
`;

export const StyledMenuItem = styled(MenuItem)`
  padding: 0 !important;

  &:hover {
    background-color: #ccc;
    outline: 1px solid #112758;
  }
`;
